import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const StrategyCardWrapper = styled.div`
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .strategy-card-top {
    display: flex;
    flex-direction: column;
    gap: 2px;

    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
    }
  }
  .not-owned-icon {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
  }
  .not-owned-icon > path {
    stroke: ${colors.black};
  }
  .not-owned-icon:hover > path {
    stroke: ${colors.primaryDark};
  }
  .strategy-automations-button {
    border: 1.2px solid ${colors.grey33};
    border-radius: 12px;
    padding: 3px 6px 4px 4px;
    align-items: center;
    width: fit-content;
    display: flex;
    gap: 4px;
    color: ${colors.black};

    &:hover {
      background: ${colors.grey6};
      cursor: pointer;
    }
  }

  .steps-counter-container {
    color: ${colors.grey11};
    border-radius: 12px;
    height: 20px;
    width: fit-content;
    line-height: 20px;
    font-size: 11px;
    font-weight: 500;
  }
`;
